// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2xjwh","header":"ReportDetails_header__fD9mp","title":"ReportDetails_title__3KVup","left":"ReportDetails_left__OMGrD"};